var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-page-container"},[(this.isLoading && !this.session)?_c('v-skeleton-loader',_vm._b({attrs:{"type":"card"}},'v-skeleton-loader',_vm.attrs,false)):_c('Session',{attrs:{"event":this.event,"session":this.session}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }